import { DuplicateCampaignOrAutomation } from "../../externalComponents/DuplicateCampaignOrAutomation";

export default function DuplicatePage() {
  return <DuplicateCampaignOrAutomation />;
}
